import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class BlogSection extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL+'/'

    return (
      <div className="blog-area pd-top-120 viaje-go-top">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-6">
		        <div className="single-blog single-blog-wrap style-two">
		          <div className="thumb single-blog-left-wrap">
		            <img src={publicUrl+"assets/img/blog/10.webp"} alt="blog" />
		          </div>
		          <div className="single-blog-details single-blog-right-wrap">
		            <Link className="tag" to="/blog-v2">América do Norte</Link>
		            <p className="date">21 fevereiro 2025</p>
		            <h4 className="title">Dicas de passeios em Cancún.</h4>
		            <p className="content">Se você está planejando uma viagem para o México , leia esse post com dicas de passeios em Cancun caso escolha por esse destino que tem sido muito visitado pelos brasileiros. O México é um país que tem muito a ser explorado. Embora a cidade de Cancún seja uma das mais visitadas há diversas opções de passeios para quem quer explorar a cidade .</p>
		            <Link className="btn btn-yellow" to="/blog-v2"><span>Saiba Mais<i className="la la-arrow-right" /></span></Link>
		          </div>
		        </div>
		      </div>
		      <div className="col-lg-6">
		        <div className="row">
		          <div className="col-sm-6">
		            <div className="single-blog style-three">
		              <div className="thumb">
		                <img src={publicUrl+"assets/img/blog/11.webp"} alt="blog" />
		              </div>
		              <div className="single-blog-details-wrap">
		                <div className="single-blog-details text-center">
		                  <Link className="tag" to="/blog-v2">América do Sul</Link>
		                  <p className="date">20 Fevereiro 2025</p>
		                  <h4 className="title">O melhor hotel do mundo está no Brasil!</h4>
		                  <Link className="btn btn-yellow" to="/blog-v2"><span>Saiba Mais<i className="la la-arrow-right" /></span></Link>
		                </div>
		              </div>
		            </div>
		          </div>
		          <div className="col-sm-6">
		            <div className="single-blog style-three">
		              <div className="thumb">
		                <img src={publicUrl+"assets/img/blog/12.webp"} alt="blog" />
		              </div>
		              <div className="single-blog-details-wrap">
		                <div className="single-blog-details text-center">
		                  <Link className="tag" to="/blog-v2">América do Sul</Link>
		                  <p className="date">24 Fevereiro 2025</p>
		                  <h4 className="title">5 passeios de águas termais na Patagônia Chilena</h4>
		                  <Link className="btn btn-yellow" to="/blog-v2"><span>Saiba Mais<i className="la la-arrow-right" /></span></Link>
		                </div>
		              </div>
		            </div>
		          </div>
		          <div className="col-sm-6">
		            <div className="single-blog style-three">
		              <div className="thumb">
		                <img src={publicUrl+"assets/img/blog/13.webp"} alt="blog" />
		              </div>
		              <div className="single-blog-details-wrap">
		                <div className="single-blog-details text-center">
		                  <Link className="tag" to="/blog-v2">Europa</Link>
		                  <p className="date">21 Fevereiro 2025</p>
		                  <h4 className="title">Melhores hotéis para ver Aurora Boreal na Noruega</h4>
		                  <Link className="btn btn-yellow" to="/blog-v2"><span>Saiba Mais<i className="la la-arrow-right" /></span></Link>
		                </div>
		              </div>
		            </div>
		          </div>
		          <div className="col-sm-6">
		            <div className="single-blog style-three">
		              <div className="thumb">
		                <img src={publicUrl+"assets/img/blog/14.webp"} alt="blog" />
		              </div>
		              <div className="single-blog-details-wrap">
		                <div className="single-blog-details text-center">
		                  <Link className="tag" to="/blog-details">América do Sul</Link>
		                  <p className="date">19 Fevereiro 2025</p>
		                  <h4 className="title">Fernando de Noronha: 5 melhores coisas para fazer</h4>
		                  <Link className="btn btn-yellow" to="/blog-v2"><span>Saiba Mais<i className="la la-arrow-right" /></span></Link>
		                </div>
		              </div>
		            </div>
		          </div>
		        </div>
		      </div>
		    </div>
		  </div>
		</div>
    )
  }
}

export default BlogSection;
